import { ActivationStatus, DeferredPorting, DeferredPortingStatus } from 'my-account/constants';
import { ModelBase } from 'store/model-base';

export class Activations extends ModelBase {
    public static storeName: string = 'activations';

    public partnerId: string;
    public serviceAccountId: string;
    public externalId: string;
    public devices: ActivationsDevices[];
    public ottServices: ActivationsOttService[];
    public newSim: ActivationsNewSim[];

    public static create<T extends ModelBase>(data: ApiResponse): T {
        return super.create<T>(data);
    }

    public getdeferredPortingStatus(imei: string): DeferredPortingStatus {
        const matchedDevice: ActivationsDevices = this.devices.find(
            (device: ActivationsDevices) => device?.details?.IMEI === imei
        );
        if (matchedDevice) {
            if (matchedDevice.activation.activationMethod === DeferredPorting.DEFERRED_PORT_IN && matchedDevice.activation.status === ActivationStatus.RFA) {

                return DeferredPortingStatus.READY_FOR_TRANSFER;
            } else if (matchedDevice.activation.statusDetail === DeferredPorting.PORT_IN_RESOLUTION_REQUIRED) {

                return DeferredPortingStatus.ERROR;
            } else if (
                [
                    DeferredPorting.PORT_IN_PROGRESS,
                    DeferredPorting.PORT_IN_CONFIRMED,
                    DeferredPorting.PORT_IN_DELAY
                ].map(String).includes(matchedDevice.activation.statusDetail)
            ) {
                return DeferredPortingStatus.IN_PROGRESS;
            }
        }

        return undefined;
    }
}
